export class SdgsConfig {
  private readonly _apiUrl: string

  constructor() {
    this._apiUrl = "/api/sdgs"
  }

  public get apiUrl() {
    return this._apiUrl
  }
}
